import { RHFRadioField } from '@openx/components-core/lib/RadioField/RHFRadioField.tsx';
import type { RadioOptionType } from '@openx/components-core/lib/RadioField/types.ts';
import type { DealFormData } from '@openx/types/deal.ts';
import { ThirdPartyFeeConfigRevenueMethod } from '@openx/types/gqlTypes.ts';
import { useMemo } from 'react';
import type { Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type RevenueMethodProps = {
  index: number;
  isDisabled?: boolean;
};

export const RevenueMethod = ({ index, isDisabled }: RevenueMethodProps) => {
  const { t } = useTranslation();

  const revenueMethodOptions = useMemo<RadioOptionType<ThirdPartyFeeConfigRevenueMethod>[]>(
    () => [
      {
        'data-test': 'third-party-fees-config-pom',
        label: t('Percent of Media'),
        value: ThirdPartyFeeConfigRevenueMethod.PoM,
      },
      {
        'data-test': 'third-party-fees-config-cpm',
        label: t('Fixed CPM'),
        value: ThirdPartyFeeConfigRevenueMethod.Cpm,
      },
    ],
    [t]
  );

  return (
    <RHFRadioField
      aria-label={t('Revenue method')}
      data-test="third-party-revenue-method"
      isDisabled={isDisabled}
      margin="dense"
      name={`third_party_fees_config.${index}.revenue_method` satisfies Path<DealFormData>}
      options={revenueMethodOptions}
      row
    />
  );
};
